import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-67af5e61"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  border: "1",
  bordercolor: "#ccc"
}
const _hoisted_3 = {
  border: "1",
  style: {"width":"calc(100% - 161px)"}
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nodata = _resolveComponent("Nodata")!
  const _component_a_spin = _resolveComponent("a-spin")!

  return (_openBlock(), _createBlock(_component_a_spin, {
    tip: "加载中...",
    spinning: _ctx.spinning
  }, {
    default: _withCtx(() => [
      ((_ctx.data|| []).length)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            _createElementVNode("div", null, [
              _createElementVNode("table", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: 'gdfx1' + i
                  }, [
                    _createElementVNode("th", null, _toDisplayString(item.title), 1)
                  ]))
                }), 128))
              ]),
              _createElementVNode("table", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: 'gdfx2' + i
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data, (td, i) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: 'gdfxtd' + i,
                        style: _normalizeStyle({'width': (100 / _ctx.columns.length) + '%' })
                      }, [
                        (item.slots && item.slots.customRender === 'peopleCount')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(td[item.key] >= 100000000 ? (td[item.key] / 100000000).toFixed(2) + '亿' : td[item.key] >= 10000 ? (td[item.key] / 10000).toFixed(2) + '万' : parseFloat(td[item.key]).toString() !== 'NaN' ? td[item.key] : '—'), 1))
                          : (item.slots && item.slots.customRender === 'increase')
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 1,
                                class: _normalizeClass([td[item.key] > 0 ? 'red' : td[item.key] < 0 ? 'green' : ''])
                              }, _toDisplayString(td[item.key] > 0 ? '+' : '') + _toDisplayString(parseFloat(td[item.key]).toString() !== 'NaN' ? (td[item.key] || 0).toFixed(2) + '%' : '—'), 3))
                            : (item.slots && item.slots.customRender === 'nocolorincrease')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(parseFloat(td[item.key]).toString() !== 'NaN' ? (td[item.key] || 0).toFixed(2) + '%' : '—'), 1))
                              : (item.slots && item.slots.customRender === 'decimal')
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(parseFloat(td[item.key]).toString() !== 'NaN' ? (td[item.key] || 0).toFixed(2) : '—'), 1))
                                : (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(td[item.key] || '—'), 1))
                      ], 4))
                    }), 128))
                  ]))
                }), 128))
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("section", _hoisted_8, [
            _createVNode(_component_Nodata, {
              nodatadesc: _ctx.itemdata.title
            }, null, 8, ["nodatadesc"])
          ]))
    ]),
    _: 1
  }, 8, ["spinning"]))
}